import { Injectable } from '@angular/core';

import { RepositoryService } from '@get/services/repository';
import { GeneratedCampagneSocieteCaracteristiqueApiService } from './campagne-societe-caracteristique-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class CampagneSocieteCaracteristiqueApiService extends GeneratedCampagneSocieteCaracteristiqueApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
